export const translations = {
  en: {
    // Units
    units: {
      pcs: 'pcs',
      kg: 'kg',
      g: 'g',
      tray: 'tray',
      unit: 'unit',
      units: 'units'
    },
    // Sidebar & Navigation
    nav: {
      dashboard: 'Dashboard',
      orders: 'Orders',
      production: 'Production',
      printCentre: 'Print Centre',
      products: 'Products',
      recipes: 'Recipes',
      customers: 'Customers',
      assignments: 'Assignments',
      orderForm: 'Order Form (Portal)',
      settings: 'Settings'
    },
    // Common Actions
    actions: {
      save: 'Save Changes',
      saved: 'Saved!',
      cancel: 'Cancel',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      viewDetails: 'View Details',
      saving: 'Saving...',
      print: 'Print',
      unlock: 'Unlock',
      lock: 'Lock',
      search: 'Search...',
      choose: '-- Choose --',
      close: 'Close',
      active: 'Active',
      inactive: 'Inactive'
    },
    // Dashboard
    dashboard: {
      title: 'Production Dashboard',
      subtitle: 'Overview of daily bakery operations.',
      totalOrders: 'Total Orders',
      totalItems: 'Total Items',
      activeProducts: 'Active Products',
      activeCustomers: 'Active Customers',
      breakdown: 'Production Breakdown',
      unitsOrdered: 'units ordered',
      loading: 'Loading dashboard...'
    },
    // Products Page
    products: {
      title: 'Products',
      subtitle: 'Manage bakery products and shared dough/base recipes.',
      addProduct: 'Add Product',
      searchPlaceholder: 'Search products...',
      allCategories: 'All Categories',
      table: {
        name: 'Product Name',
        recipe: 'Shared Recipe (Dough)',
        weight: 'Dough Weight',
        status: 'Status',
        actions: 'Actions'
      },
      form: {
        name: 'Product Name',
        category: 'Category',
        subcategory: 'Subcategory',
        sharedRecipe: 'Shared Dough/Base',
        noRecipe: '-- No Shared Recipe --',
        weightG: 'Dough Weight (g)',
        unit: 'Unit',
        isActive: 'Product is Active',
        showOnForm: 'Show on Order Form',
        notes: 'Notes',
        save: 'Save Product'
      },
      deleteConfirm: 'Are you sure you want to PERMANENTLY delete "{name}"?\n\nThis will:\n- Remove the product profile\n- Remove all customer assignments\n\nNote: Historical orders will be kept for records but will show as "Unknown Product".'
    },
    // Recipes Page
    recipes: {
      title: 'Recipes',
      subtitle: 'Manage bakery recipes, yields, and ingredients.',
      addRecipe: 'Add Recipe',
      table: {
        name: 'Recipe Name',
        type: 'Type',
        capacity: 'Capacity/Yield',
        linked: 'Linked Products',
        actions: 'Actions'
      },
      form: {
        titleAdd: 'Add Recipe',
        titleEdit: 'Edit Recipe',
        name: 'Recipe Name',
        type: 'Recipe Type',
        batchYield: 'Batch Yield',
        mixerCapacity: 'Mixer Capacity (g)',
        unit: 'Unit',
        ingredients: 'Ingredients (Baker\'s %)',
        addRow: 'Add Row',
        ingredient: 'Ingredient',
        bakerPct: 'Baker %',
        notes: 'Notes',
        productionNotes: 'Production Notes',
        isActive: 'Recipe is Active',
        save: 'Save Recipe'
      },
      deleteConfirm: 'Are you sure you want to PERMANENTLY delete "{name}"?{warning}\n\nThis action cannot be undone.',
      linkedWarning: '\n\nWARNING: {count} product(s) are linked to this recipe. Deleting it will unlink them.'
    },
    // Production Page
    production: {
      title: 'Production Summary',
      subtitle: 'Daily ingredient requirements scaled to total order volume.',
      noProduction: 'No Production Needed',
      noOrders: 'There are no orders scheduled for delivery on this date.',
      requiredDough: 'Required Dough',
      suggestedBatches: 'Suggested Batches',
      ingredientScale: 'Daily Ingredient Scale',
      contributingOrders: 'Contributing Orders',
      standalone: 'Stand-alone Products (No Recipe Linked)',
      noPercentages: 'No baker\'s percentages defined for this recipe.',
      calculating: 'Calculating requirements...',
      dailyScaled: 'Daily Scaled Batch'
    },
    // Customers Page
    customers: {
      title: 'Customers',
      subtitle: 'Manage wholesale and retail clients.',
      addCustomer: 'Add Customer',
      form: {
        titleAdd: 'Add Customer',
        titleEdit: 'Edit Customer',
        businessName: 'Business Name',
        contactName: 'Contact Name',
        type: 'Type',
        email: 'Email',
        phone: 'Phone',
        deliveryDays: 'Delivery Days',
        slug: 'Order Form Slug (Unique)',
        isActive: 'Customer is Active',
        save: 'Save Customer'
      },
      types: {
        wholesale: 'Wholesale',
        retail: 'Retail',
        internal: 'Internal'
      }
    },
    // Assignments Page
    assignments: {
      title: 'Customer Assignments',
      subtitle: 'Control which products appear on each customer\'s order form.',
      selectCustomer: 'Select Customer',
      availableProducts: 'Available Products',
      save: 'Save Assignments',
      placeholder: 'Select a customer to assign products',
      orderLink: 'Unique Order Link:'
    },
    // Orders Page
    orders: {
      title: 'Orders',
      subtitle: 'View and manage customer orders.',
      table: {
        date: 'Delivery Date',
        customer: 'Customer',
        status: 'Status',
        total: 'Total Items',
        actions: 'Actions'
      },
      noOrders: 'No orders found.',
      details: {
        title: 'Order Details',
        delivery: 'Delivery:',
        customer: 'Customer',
        product: 'Product',
        qty: 'Quantity',
        notes: 'Notes:'
      }
    },
    // Order Form (Portal)
    orderForm: {
      title: 'Bakery Order Form',
      subtitle: 'Place your wholesale order easily.',
      selectAccount: 'Select Your Business',
      chooseAccount: '-- Choose Account --',
      deliveryDate: 'Delivery Date',
      noProducts: 'No products are currently assigned to this account. Please contact the bakery.',
      notesLabel: 'Order Notes (Optional)',
      notesPlaceholder: 'Any special instructions...',
      submit: 'Submit Order',
      submitting: 'Submitting...',
      invalidLink: 'Invalid Order Link',
      invalidLinkDesc: 'The link you used is incorrect or the account is no longer active. Please contact the bakery for a valid link.',
      noSlugProvided: 'Private Portal',
      noSlugProvidedDesc: 'This order form is private. Please use the unique link provided to you by the bakery.',
      success: {
        title: 'Order Received!',
        desc: 'Your order has been successfully submitted to the bakery.',
        button: 'Place Another Order'
      }
    },
    // Print Labels
    print: {
      deliveryNote: 'Delivery Note',
      deliveryDate: 'Delivery Date',
      deliverTo: 'Deliver To',
      orderRef: 'Order Ref',
      description: 'Product Description',
      qty: 'Qty',
      unit: 'Unit',
      receivedBy: 'Received By',
      deliveredBy: 'Delivered By',
      totalNeeded: 'Total Needed',
      mixerCapacity: 'Mixer Capacity',
      batch: 'Batch',
      of: 'of',
      fullBatch: 'Full Production Batch',
      ingredient: 'Ingredient',
      bakerPct: 'Baker %',
      weight: 'Weight',
      fullProduction: 'Full Production',
      recipeSheet: 'Recipe Sheet',
      selectRecipe: '-- Select Recipe --',
      allCustomers: 'All Customers',
      centreSubtitle: 'Generate packing slips and production sheets for printing.'
    },
    // Settings
    settings: {
      title: 'System Settings',
      subtitle: 'Configure your bakery identity and preferences.',
      locked: 'Settings Locked',
      lockedDesc: 'Please enter the security PIN to access system configuration.',
      language: 'Language',
      companyIdentity: 'Company Identity',
      printPrefs: 'Print Preferences',
      systemConfig: 'System Configuration',
      securityPin: 'Security PIN (Settings Access)',
      gasUrl: 'Google Apps Script URL',
      sheetId: 'Google Spreadsheet ID',
      showLogo: 'Show Logo on Printouts',
      showAddress: 'Show Address on Printouts',
      footerText: 'Footer Text'
    }
  },
  da: {
    // Units
    units: {
      pcs: 'stk.',
      kg: 'kg',
      g: 'g',
      tray: 'bakke',
      unit: 'enhed',
      units: 'enheder'
    },
    // Sidebar & Navigation
    nav: {
      dashboard: 'Kontrolpanel',
      orders: 'Ordrer',
      production: 'Produktion',
      printCentre: 'Printcenter',
      products: 'Produkter',
      recipes: 'Opskrifter',
      customers: 'Kunder',
      assignments: 'Tildelinger',
      orderForm: 'Bestillingsformular',
      settings: 'Indstillinger'
    },
    // Common Actions
    actions: {
      save: 'Gem ændringer',
      saved: 'Gemt!',
      cancel: 'Annuller',
      add: 'Tilføj',
      edit: 'Rediger',
      delete: 'Slet',
      viewDetails: 'Vis detaljer',
      saving: 'Gemmer...',
      print: 'Print',
      unlock: 'Lås op',
      lock: 'Lås',
      search: 'Søg...',
      choose: '-- Vælg --',
      close: 'Luk',
      active: 'Aktiv',
      inactive: 'Inaktiv'
    },
    // Dashboard
    dashboard: {
      title: 'Produktionsoversigt',
      subtitle: 'Overblik over dagens bageridrift.',
      totalOrders: 'Antal Ordrer',
      totalItems: 'Antal Enheder',
      activeProducts: 'Aktive Produkter',
      activeCustomers: 'Aktive Kunder',
      breakdown: 'Produktionsfordeling',
      unitsOrdered: 'enheder bestilt',
      loading: 'Indlæser dashboard...'
    },
    // Products Page
    products: {
      title: 'Produkter',
      subtitle: 'Administrer bageriprodukter og fælles dejopskrifter.',
      addProduct: 'Tilføj Produkt',
      searchPlaceholder: 'Søg produkter...',
      allCategories: 'Alle Kategorier',
      table: {
        name: 'Produktnavn',
        recipe: 'Fælles Opskrift (Dej)',
        weight: 'Dejvægt',
        status: 'Status',
        actions: 'Handlinger'
      },
      form: {
        name: 'Produktnavn',
        category: 'Kategori',
        subcategory: 'Underkategori',
        sharedRecipe: 'Fælles Dej/Base',
        noRecipe: '-- Ingen fælles opskrift --',
        weightG: 'Dejvægt (g)',
        unit: 'Enhed',
        isActive: 'Produktet er aktivt',
        showOnForm: 'Vis på bestillingsseddel',
        notes: 'Noter',
        save: 'Gem Produkt'
      },
      deleteConfirm: 'Er du sikker på, at du vil slette "{name}" PERMANENT?\n\nDette vil:\n- Fjerne produktprofilen\n- Fjerne alle kundetildelinger\n\nBemærk: Historiske ordrer bevares som dokumentation, men vil blive vist som "Ukendt produkt".'
    },
    // Recipes Page
    recipes: {
      title: 'Opskrifter',
      subtitle: 'Administrer opskrifter, udbytte og ingredienser.',
      addRecipe: 'Tilføj Opskrift',
      table: {
        name: 'Opskrift Navn',
        type: 'Type',
        capacity: 'Kapacitet/Udbytte',
        linked: 'Tilknyttede Produkter',
        actions: 'Handlinger'
      },
      form: {
        titleAdd: 'Tilføj Opskrift',
        titleEdit: 'Rediger Opskrift',
        name: 'Opskrift Navn',
        type: 'Opskriftstype',
        batchYield: 'Batch Udbytte',
        mixerCapacity: 'Røremaskine Kapacitet (g)',
        unit: 'Enhed',
        ingredients: 'Ingredienser (Bager %)',
        addRow: 'Tilføj række',
        ingredient: 'Ingrediens',
        bakerPct: 'Bager %',
        notes: 'Noter',
        productionNotes: 'Produktionsnoter',
        isActive: 'Opskriften er aktiv',
        save: 'Gem Opskrift'
      },
      deleteConfirm: 'Er du sikker på, at du vil slette "{name}" PERMANENT?{warning}\n\nDette kan ikke fortrydes.',
      linkedWarning: '\n\nADVARSEL: {count} produkt(er) er tilknyttet denne opskrift. Sletning vil fjerne tilknytningen.'
    },
    // Production Page
    production: {
      title: 'Produktionsopsummering',
      subtitle: 'Daglige ingrediensbehov skaleret til det samlede ordrevolumen.',
      noProduction: 'Ingen produktion nødvendig',
      noOrders: 'Der er ingen ordrer planlagt til levering på denne dato.',
      requiredDough: 'Nødvendig dej',
      suggestedBatches: 'Foreslåede batches',
      ingredientScale: 'Daglig ingrediensskala',
      contributingOrders: 'Bidragende ordrer',
      standalone: 'Enkelte produkter (Ingen opskrift tilknyttet)',
      noPercentages: 'Ingen bager-procenter defineret for denne opskrift.',
      calculating: 'Beregner behov...',
      dailyScaled: 'Daglig skaleret batch'
    },
    // Customers Page
    customers: {
      title: 'Kunder',
      subtitle: 'Administrer engros- og detailkunder.',
      addCustomer: 'Tilføj Kunde',
      form: {
        titleAdd: 'Tilføj Kunde',
        titleEdit: 'Rediger Kunde',
        businessName: 'Virksomhedsnavn',
        contactName: 'Kontaktperson',
        type: 'Type',
        email: 'E-mail',
        phone: 'Telefon',
        deliveryDays: 'Leveringsdage',
        slug: 'Bestillings-ID (Unik)',
        isActive: 'Kunden er aktiv',
        save: 'Gem Kunde'
      },
      types: {
        wholesale: 'Engros',
        retail: 'Detail',
        internal: 'Intern'
      }
    },
    // Assignments Page
    assignments: {
      title: 'Kundetildelinger',
      subtitle: 'Styr hvilke produkter der vises på hver kundes bestillingsseddel.',
      selectCustomer: 'Vælg Kunde',
      availableProducts: 'Tilgængelige Produkter',
      save: 'Gem Tildelinger',
      placeholder: 'Vælg en kunde for at tildele produkter',
      orderLink: 'Unikt Bestillingslink:'
    },
    // Orders Page
    orders: {
      title: 'Ordrer',
      subtitle: 'Vis og administrer kundebestillinger.',
      table: {
        date: 'Leveringsdato',
        customer: 'Kunde',
        status: 'Status',
        total: 'Total Antal',
        actions: 'Handlinger'
      },
      noOrders: 'Ingen ordrer fundet.',
      details: {
        title: 'Ordredetaljer',
        delivery: 'Levering:',
        customer: 'Kunde',
        product: 'Produkt',
        qty: 'Antal',
        notes: 'Noter:'
      }
    },
    // Order Form (Portal)
    orderForm: {
      title: 'Bestillingsformular',
      subtitle: 'Afgiv din engrosbestilling nemt.',
      selectAccount: 'Vælg din virksomhed',
      chooseAccount: '-- Vælg Konto --',
      deliveryDate: 'Leveringsdato',
      noProducts: 'Der er i øjeblikket ingen produkter tildelt denne konto. Kontakt venligst bageriet.',
      notesLabel: 'Ordrenoter (Valgfrit)',
      notesPlaceholder: 'Særlige instruktioner...',
      submit: 'Indsend Bestilling',
      submitting: 'Indsender...',
      invalidLink: 'Ugyldigt Bestillingslink',
      invalidLinkDesc: 'Linket du brugte er forkert, eller kontoen er ikke længere aktiv. Kontakt venligst bageriet for et gyldigt link.',
      noSlugProvided: 'Privat Portal',
      noSlugProvidedDesc: 'Denne bestillingsformular er privat. Brug venligst det unikke link, du har fået udleveret af bageriet.',
      success: {
        title: 'Bestilling Modtaget!',
        desc: 'Din bestilling er blevet sendt til bageriet.',
        button: 'Afgiv en ny bestilling'
      }
    },
    // Print Labels
    print: {
      deliveryNote: 'Følgeseddel',
      deliveryDate: 'Leveringsdato',
      deliverTo: 'Leveres til',
      orderRef: 'Ordre ref.',
      description: 'Produktbeskrivelse',
      qty: 'Antal',
      unit: 'Enhed',
      receivedBy: 'Modtaget af',
      deliveredBy: 'Leveret af',
      totalNeeded: 'Total behov',
      mixerCapacity: 'Røremaskine kapacitet',
      batch: 'Batch',
      of: 'af',
      fullBatch: 'Fuld produktionsbatch',
      ingredient: 'Ingrediens',
      bakerPct: 'Bager %',
      weight: 'Vægt',
      fullProduction: 'Fuld Produktion',
      recipeSheet: 'Opskriftsark',
      selectRecipe: '-- Vælg Opskrift --',
      allCustomers: 'Alle Kunder',
      centreSubtitle: 'Generer pakkesedler og produktionsark til print.'
    },
    // Settings
    settings: {
      title: 'Systemindstillinger',
      subtitle: 'Konfigurer din bageri-identitet og præferencer.',
      locked: 'Indstillinger låst',
      lockedDesc: 'Indtast venligst sikkerheds-PIN for at få adgang til systemkonfigurationen.',
      language: 'Sprog',
      companyIdentity: 'Virksomhedsidentitet',
      printPrefs: 'Printindstillinger',
      systemConfig: 'Systemkonfiguration',
      securityPin: 'Sikkerheds-PIN (Adgang til indstillinger)',
      gasUrl: 'Google Apps Script URL',
      sheetId: 'Google Spreadsheet ID',
      showLogo: 'Vis logo på print',
      showAddress: 'Vis adresse på print',
      footerText: 'Fodtekst'
    }
  }
};